export const ROUTES = {
  LOGIN: '/login',
  DASHBOARD: '/',

  ENTITY_REGISTRY: '/entity-registry',
  ENTITY_REGISTRY_NEW: '/entity-registry/new',
  ENTITY_REGISTRY_EDIT: '/entity-registry/:entityName',
  ENTITY_REGISTRY_GRAPH: '/entity-registry/graph',

  MAPPINGS: '/mappings',
  MAPPING_NEW: '/mappings/new',
  MAPPING_EDIT: '/mappings/:entityName',

  SCHEMAS: '/schemas',
  SCHEMA_NEW: '/schemas/new',
  SCHEMA_EDIT: '/schemas/:entityName',

  LOOKUP_TABLES: '/lookup-tables',
  LOOKUP_TABLE_NEW: '/lookup-tables/new',
  LOOKUP_TABLE_EDIT: '/lookup-tables/:tableName',

  UOM_CONVERSIONS: '/uom-conversions',
  UOM_CONVERSION_NEW: '/uom-conversions/new',
  UOM_CONVERSION_EDIT: '/uom-conversions/:tableName',

  CONNECTIONS: '/connections',
  CONNECTION_NEW: '/connections/new',
  CONNECTION_EDIT: '/connections/:system',

  SETUP: '/setup',

  SYSTEMS: '/systems',

  WORKFLOWS: '/workflows',

  DEAD_LETTER_QUEUES: '/dead-letter-queues',

  USERS: '/users',
  COMPANIES: '/companies',
  SETTINGS: '/settings',

  DEMO_INBOX: '/demo-inbox',
  QUOTA: '/quota',
  AUDIT_TRAIL: '/audit-trail',
  INTEGRATION_AUDIT: '/integration-audit',

  CONFIG_SYNC: '/config-sync',
  POLLING_STATUS: '/polling-status',
  INITIAL_LOAD: '/initial-load',
  INITIAL_LOAD_DETAIL: '/initial-load/:jobId',
  RECONCILIATION: '/reconciliation',
  DATA_HUB: '/data-hub',
  DATA_HUB_DASHBOARDS: '/data-hub/dashboards',
  DATA_HUB_EXPLORE: '/data-hub/explore',
  DATA_HUB_REPORTS: '/data-hub/reports',
  DATA_HUB_AGENTS: '/data-hub/agents',
  DATA_HUB_POWERBI: '/data-hub/power-bi',
  DATA_HUB_TABLES: '/data-hub/tables',
  DOCUMENTS: '/documents',
  DOCUMENTS_INSTRUCTIONS: '/documents/instructions',
  DOCUMENT_REVIEW: '/documents/:documentId',
  ALERTS: '/alerts',

  TERMS_OF_SERVICE: '/legal/terms',
  PRIVACY_POLICY: '/legal/privacy',
  DATA_PROCESSING_AGREEMENT: '/legal/dpa',
  ACCEPTABLE_USE_POLICY: '/legal/aup',
  SERVICE_LEVEL_AGREEMENT: '/legal/sla',
  SECURITY: '/legal/security',
} as const;
